document.addEventListener('DOMContentLoaded', function() {
  // Étape 1 : Masquer les réponses par défaut
  var anwsers = document.querySelectorAll('.step1 .grid__cell--quizz-answer');
  anwsers.forEach(function(anwser) {
    anwser.classList.add('hide');
  });
  var slideNextElement = document.querySelector('[data-question-id="Accueil"] [data-action="slide-next"]');
  if (slideNextElement) {
    slideNextElement.addEventListener('click', function(el) {
      anwSelected = document.querySelector('.quizz__answer.quizz-answer.selected .quizz-answer__title');
      if(anwSelected){
        class_name = anwSelected.className.split('quizz-answer__title-')[1];
        class_id = class_name.split(' ')[0];
        anwsers.forEach(function(anwser) {
          if (anwser.classList.contains('anwser-' + class_id)) {
            anwser.classList.remove('hide');
          }
        });
      }else {
        console.log('Pas de réponse sélectionnée');
      }
    });
  } else {
    console.error("L'élément avec l'attribut data-action='slide-next' n'a pas été trouvé.");
  }

  var slidePrevElement = document.querySelector('.carousel__item.step1 [data-action="slide-prev"]');
  if (slidePrevElement) {
    slidePrevElement.addEventListener('click', function(el) {
      var blocks = document.querySelectorAll('.carousel__item.step1 .grid__cell--quizz-answer');
      blocks.forEach(function(block) {
        block.classList.add('hide');
      });
    });
  } else {
    console.log("L'élément avec l'attribut data-action='slide-prev' n'a pas été trouvé 1.");
  }
});

/* Traitement JSON */
var slideNextStep2 = document.querySelector('.carousel__item.step1 [data-action="slide-next"]');
if(slideNextStep2){
  slideNextStep2.addEventListener('click', function(el) {
    const url = 'https:' + `${botJsonFile}`;

    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        var i = 1;
        data.step3.forEach(function(reponse) {
          var refid = document.querySelector('.carousel__item.step1 .quizz__answers_list .quizz-answer.selected').attributes[3].value;     
          if(refid == reponse.reference){
            var container = document.querySelector('.carousel__item.step2 .quizz__answers_list');
            var anwser = document.createElement('div');
            anwser.classList.add('grid__cell--quizz-answer','anwser');
            var quizz_answer = document.createElement('div');
            quizz_answer.classList.add('quizz__answer','quizz-answer');
            quizz_answer.setAttribute('data-question-type', 'question_multiple');
            quizz_answer.setAttribute('data-parent-type', 'question_multiple');
            quizz_answer.setAttribute('data-answer-tag', 'question_3-reponse_1');
            quizz_answer.setAttribute('data-get-infos', i);
            var quizz_answer__title = document.createElement('div');
            quizz_answer__title.classList.add('quizz-answer__title','quizz-answer__title');
            var subchoice = document.createElement('p');
            subchoice.classList.add('subchoice');
            container.appendChild(anwser);
            anwser.appendChild(quizz_answer);
            quizz_answer.appendChild(quizz_answer__title);
            quizz_answer__title.appendChild(subchoice);    
            subchoice.innerHTML = reponse.content;
            var span = document.createElement('span');
            subchoice.appendChild(span);
            span.innerHTML += reponse.q_suiv;
            span.style.display = "none";
            anwser.addEventListener('click', function(el) {
              var btnValider3 = document.querySelector('.carousel__item.step2 [data-action="slide-next"]');
                if(btnValider3){
                  btnValider3.click();
                }
              });
            // var pb_title = document.querySelector('.carousel__item.step2 .question .h2');
            // if(reponse.message !== undefined){
            //   pb_title.innerHTML = reponse.message.textContent;
            // }
            i++;
          }else{
            console.log('Des éléments ne correspondant pas ont été trouvés');
          }
        });
        var subchoices = document.querySelectorAll('.carousel__item.step2 .quizz__answer');
        subchoices.forEach(function(subchoice) {
          subchoice.addEventListener('click', function(el) {
            var subchoice = document.querySelector('.carousel__item.step2 .quizz__answer.selected');
            if(subchoice){
              subchoice.classList.remove('selected');
            }
            this.classList.add('selected');
          });
        });
        var slidePrevElementStep2 = document.querySelectorAll('.carousel__item.step2 .removed');
        if (slidePrevElementStep2) {
          slidePrevElementStep2.forEach(function(slidePrevElementStep2) {
            slidePrevElementStep2.addEventListener('click', function(el) {
              var blocks = document.querySelectorAll('.carousel__item.step2 .grid__cell--quizz-answer');
              blocks.forEach(function(block) {
                block.remove();
              });
            });
          });
          var noLast = document.querySelector('.carousel__item.step2 .quizz-answer .subchoice.lastStep');
          if(noLast){
            noLast.classList.remove('lastStep');
          }
        } else {
          console.log("L'élément avec l'attribut data-action='slide-prev' n'a pas été trouvé 1.");
        }
        var q_suiv = document.querySelector('.carousel__item.step2 .quizz-answer .subchoice span');
        var btn_qu_next = document.querySelector('.carousel__item.step2 .button-container');
        if(q_suiv){
          if(q_suiv.textContent === ""){
            btn_qu_next.style.display = "none";
            var lastStep = document.querySelector('.carousel__item.step2 .quizz-answer .subchoice');
            lastStep.classList.add('lastStep');
            lastStep.style.borderColor = "#fff";
            lastStep.style.borderRadius = "0";
            lastStep.style.background = "#fffdfa";
            lastStep.style.padding = "18px 12px";
            lastStep.style.textAlign = "left";
            //On ne peux pas cliquer sur la dernière réponse
            lastStep.addEventListener('click', function(el) {
              el.preventDefault();
              el.stopPropagation();
            });
            var q_prec = document.querySelector('.carousel__item.step2 .q_prec');
            q_prec.style.display = "none";
            var q_restart = document.querySelector('.carousel__item.step2 .restart');
            q_restart.classList.remove('hide');
            var visit_store = document.querySelector('.carousel__item.step2 .visit_store');
            visit_store.classList.remove('hide');
          }else{
            btn_qu_next.style.display = "block";
          }
        }
        // var lastMessage = document.createElement('p');
        // lastMessage.classList.add('lastMessage');
        // lastMessage.innerHTML = "Voici la réponse à votre question";
        // var lastMessageContainer = document.querySelector('.carousel__item.step2 .quizz-answer__title');
        // lastMessageContainer.appendChild(lastMessage);
      });
  })
}

var slideNextStep3 = document.querySelector('.carousel__item.step2 [data-action="slide-next"]');
if(slideNextStep3){
  slideNextStep3.addEventListener('click', function(el) {
    const url = 'https:' + `${botJsonFile}`;

    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        data.step4.forEach(function(reponse) {
          var refid = document.querySelector('.carousel__item.step1 .quizz__answers_list .quizz-answer.selected').attributes[3].value;
          var ref_value = document.querySelector('.carousel__item.step2 .quizz__answers_list .quizz-answer.selected').attributes[4].value;
          var ref = refid + '_' + ref_value;
          if(ref == reponse.reference){
            var container = document.querySelector('.carousel__item.step3 .quizz__answers_list');
            var anwser = document.createElement('div');
            anwser.classList.add('grid__cell--quizz-answer','anwser');
            var quizz_answer = document.createElement('div');
            quizz_answer.classList.add('quizz__answer','quizz-answer');
            quizz_answer.setAttribute('data-question-type', 'question_multiple');
            quizz_answer.setAttribute('data-parent-type', 'question_multiple');
            quizz_answer.setAttribute('data-answer-tag', 'question_3-reponse_1');
            quizz_answer.setAttribute('data-get-infos', 'inutile');
            var quizz_answer__title = document.createElement('div');
            quizz_answer__title.classList.add('quizz-answer__title','quizz-answer__title');
            var subchoice = document.createElement('p');
            subchoice.classList.add('subchoice');
            container.appendChild(anwser);
            anwser.appendChild(quizz_answer);
            quizz_answer.appendChild(quizz_answer__title);
            quizz_answer__title.appendChild(subchoice);    
            subchoice.innerHTML = reponse.content;
            // var pb_title = document.querySelector('.carousel__item.step3 .question .h2');
            // if(reponse.message !== null){
            //   pb_title.innerHTML = reponse.message.textContent;
            // }
          }
        });
        var visit_store = document.querySelector('.carousel__item.step3 .visit_store');
        visit_store.classList.remove('hide');
        var subchoices = document.querySelectorAll('.carousel__item.step3 .quizz__answer');
        subchoices.forEach(function(subchoice) {
          subchoice.addEventListener('click', function(el) {
            var subchoice = document.querySelector('.carousel__item.step3 .quizz__answer.selected');
            if(subchoice){
              subchoice.classList.remove('selected');
            }
            this.classList.add('selected');
          });
        });
        var slidePrevElementStep3 = document.querySelectorAll('.carousel__item.step3 .removed');
        if (slidePrevElementStep3) {
          slidePrevElementStep3.forEach(function(slidePrevElementStep3) {
            slidePrevElementStep3.addEventListener('click', function(el) {
              var blocks = document.querySelectorAll('.carousel__item.step3 .grid__cell--quizz-answer');
              blocks.forEach(function(block) {
                block.remove();
              });
              var blocks2 = document.querySelectorAll('.carousel__item.step2 .grid__cell--quizz-answer');
              blocks2.forEach(function(block) {
                block.remove();
              });
            });
          });
        } else {
          console.log("L'élément avec l'attribut data-action='slide-prev' n'a pas été trouvé 1.");
        }
      });
  })
}

var reponsesValider1 = document.querySelectorAll('.carousel__item.step0 .grid__cell--quizz-answer');
reponsesValider1.forEach(function(btnValider1) {
  btnValider1.addEventListener('click', function(el) {
    var btnValider1 = document.querySelector('.carousel__item.step0 [data-action="slide-next"]');
    if(btnValider1){
      btnValider1.click();
    }
  });
});
var reponsesValider2 = document.querySelectorAll('.carousel__item.step1 .grid__cell--quizz-answer');
reponsesValider2.forEach(function(btnValider2) {
  btnValider2.addEventListener('click', function(el) {
    var btnValider2 = document.querySelector('.carousel__item.step1 [data-action="slide-next"]');
    if(btnValider2){
      btnValider2.click();
    }
  });
});
var reponsesValider3 = document.querySelectorAll('.carousel__item.step2 .grid__cell--quizz-answer');
reponsesValider3.forEach(function(btnValider3) {
  btnValider3.addEventListener('click', function(el) {
    var btnValider3 = document.querySelector('.carousel__item.step2 [data-action="slide-next"]');
    if(btnValider3){
      btnValider3.click();
    }
  });
});
  

(function ($) {

  // Retourne la direction du slide
  function getSlideDirection($currentSlide, $nextSlide) {
    if ($currentSlide < $nextSlide) {
      return 'right';
    } else {
      return 'left';
    }
  }

  // Affiche la question précédente
  function goToPrevQuestion($prev_slide_index) {
    if (!$prev_slide_index || $prev_slide_index == "") {
      $('.quizz__carousel').slick('slickPrev');
    } else {
      $('.quizz__carousel').slick('slickGoTo', parseInt($prev_slide_index) - 1);
    }
  }

  // Affiche la question suivante
  function goToNextQuestion($next_slide_index) {
    if ($next_slide_index == "") {
      $('.quizz__carousel').slick('slickNext');
      // $("input").blur()
    } else {
      $('.quizz__carousel').slick('slickGoTo', parseInt($next_slide_index) - 1);
      // $("input").blur()
    }
  }

  $(document).ready(function () {

    // Show the slider only when this one is initialized
    $('.quizz__carousel').on('init', function (event, slick) {
      $('.quizz__carousel').css('opacity', '1');
    })

    $('.quizz__carousel .restart').on('click', function () {
      $('.quizz__carousel').slick('slickGoTo', 1);
      $('.carousel__item.step2 .q_prec').css('display', 'flex');
      $('.carousel__item.step2 .restart').addClass('hide');
      $('.carousel__item.step2 .visit_store').addClass('hide');
      $('.step1 .grid__cell--quizz-answer').addClass('hide');

    }); 


    // initialize the slick function
    $('.quizz__carousel').slick({
      accessibility: true,
      autoplay: false,
      arrows: false,
      dots: true,
      draggable: false,
      infinite: false,
      mobileFirst: true,
      swipe: false,
      touchMove: true,
      //adaptativeHeight: true,
      touchThreshold: 10
    });

    // Désactive le clic sur les slick dots
    $('.quizz__carousel .slick-dots button').each(function () {
      $(this).attr('disabled', 'disabled');
    });
  });

  // Avant de passer au slide suivant
  $('.quizz__carousel').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    if($('.slick-current').hasClass('step1')) {
      //console.log('Code à mettre ici');
    }

    // On stock les réponses sélectionnées
    var $slide_direction = getSlideDirection(currentSlide, nextSlide);
    var $current_slide = $('.carousel__item.slick-current');
    var $current_question_type = $current_slide.data('question-type');
    if ($current_question_type != 'question_email') {
      var $current_question = $current_slide.find('.quizz-question').eq(0);
    } else {
      var $current_question = $current_slide.find('.quizz-question').eq(1);
    }

    var $answer_result = '';

    if ($slide_direction == 'right') {
      if ($current_question_type == 'question_texte') {
        var $input = $current_question.find('.quizz-answers').eq(0).find('.quizz-answer').find('input').eq(0);
        $answer_result = $input.val();
        // Pour l'inscription dans le storage local pour l'affichage sur la page résultat
        let $question = $input.data("get-infos");
        localStorage.setItem($question, $answer_result);
      }

      if ($current_question_type == 'question_multiple') {
        var $current_answers_selected = $current_question.find('.quizz-answers').eq(0).find('.quizz-answer.selected');
        $current_answers_selected.each(function ($index) {
          var $answer_tag = $(this).data('answer-tag');
          var $answer_text = $(this).find('.quizz-answer__title').find('p').eq(0).text();
          // On sauvegarde les réponses
          var $answer_tag_question = $answer_tag.split('-')[0];
          var $answer_tag_answer = $answer_tag.split('-')[1];
          if ($index > 0) {
            $answer_result = $answer_result + ' / ' + $answer_tag_answer;
          } else {
            $answer_result = $answer_result + $answer_tag_answer;
          }
        });
        // Pour l'inscription dans le storage local pour l'affichage sur la page résultat
        let $question = $current_answers_selected.data("get-infos");
        localStorage.setItem($question, $answer_result);
      }
      if ($current_question_type == 'question_multiple_color') {
        var $current_answers_selected = $current_question.find('.quizz-answers').eq(0).find('.quizz-answer.selected');
        $current_answers_selected.each(function ($index) {
          var $answer_tag = $(this).data('answer-tag');
          var $answer_text = $(this).find('.quizz-answer__title').find('p').eq(0).text();
          // On sauvegarde les réponses
          var $answer_tag_answer = $answer_tag.split('-')[1];
          if ($index > 0) {
            $answer_result = $answer_result + ' / ' + $answer_tag_answer;
          } else {
            $answer_result = $answer_result + $answer_tag_answer;
          }
        });
        // Pour l'inscription dans le storage local pour l'affichage sur la page résultat
        let $question = $current_answers_selected.data("get-infos");
        localStorage.setItem($question, $answer_result);
      }

      // On active le 'Z' qui vient d'être passé
      $('.slick-dots').find('.slick-active').toggleClass('done');
    } else {
      // On désactive le 'Z' qui vient d'être passé
      if ($('.slick-dots').find('.slick-active').hasClass('done')) {
        $('.slick-dots').find('.slick-active').toggleClass('done');
      }
    }
  });

  // Après être passé au slide suivant
  $('.quizz__carousel').on('afterChange', function (event, slick, currentSlide, nextSlide) {
    var $current_slide = $('.carousel__item.slick-current');
    var $current_question = $current_slide.find('.quizz-question').eq(0);
    var $current_question_type = $current_question.data('question-type');

    // On active les 'Z' qui viennent d'être passés si on avance de plusieurs slides
    $('.slick-dots').find('.slick-active').prevAll('li:not(.done)').each(function () {
      $(this).toggleClass('done');
    });

    // On désactive les 'Z' qui viennent d'être passés si on recule de plusieurs slides
    $('.slick-dots').find('.slick-active').nextAll('li.done').each(function () {
      $(this).toggleClass('done');
    });


    // On passe automatiquement au slide suivant si c'est une question simple qui n'a pas de bouton
    if ($current_question_type == 'question_simple' && $current_question.find('.btn').length == 0) {
      setTimeout(function () {
        goToNextQuestion("");
      }, 1500);
    }

    // On remonte en haut de la page
    $('html, body').animate({
      scrollTop: 0
    }, 0);
  });

  // Au clic sur une réponse multiple
  $('.quizz-question_multiple .quizz-answer').on('click', function () {
    var $this = $(this);
    var $parent_type = $this.data('parent-type');
    var $allow_multiple_answers = $this.parent().parent().data('multiple-answers');
    var $selected_answers = $this.parent().parent().find('.selected');

    if ($parent_type != 'question_email') {
      if (!$allow_multiple_answers) {
        // On déselectionne l'éventuelle autre réponse sélectionnée
        if ($selected_answers.length > 0) {
          $selected_answers.each(function () {
            $(this).removeClass('selected');
          });
        }
        // On sélectionne la nouvelle réponse
        $this.toggleClass('selected');
        // On passe à la question suivante
        if($parent_type != 'question_multiple_color') {
          var $next_slide_index = $(this).data('next-slide');
          goToNextQuestion($next_slide_index);
        }
      } else {

        // On sélectionne la nouvelle réponse
        $this.toggleClass('selected');

      }
    } else {
      // On sélectionne la nouvelle réponse
      $this.toggleClass('selected');

      // On affiche le bon block en fonction du choix
      var $answer_tag = Array.from($this.data('answer-tag'));
      var $index_to_hide = 0;
      var $index_to_show = parseInt($answer_tag.pop());
      var $parent_question = $this.parent().parent().parent().parent().parent();
      $parent_question.find('.quizz-question').eq($index_to_hide).addClass('slide-left');
      setTimeout(function () {
        $parent_question.find('.quizz-question').eq($index_to_hide).addClass('hidden-pocket');
      }, 700);
      setTimeout(function () {
        $parent_question.find('.quizz-question').eq($index_to_show).removeClass('hidden-pocket');
      }, 700);
      $parent_question.find('.quizz-question').eq($index_to_show).addClass('slide-left');
    }
  });


  // Au clic sur le bouton valider d'une réponse
  $('[data-action="slide-next"]').on('click', function (el) {
    var $this = $(this);
    var $question_type = $this.data('question-type');
    var $next_slide_index = $(this).data('next-slide');
    switch ($question_type) {
      case 'question_simple':
        goToNextQuestion($next_slide_index);
        break;
      case 'question_multiple':
        var $selected_answers = $this.parent().parent().prev().find('.selected');
        if ($selected_answers.length > 0) {
          goToNextQuestion($next_slide_index);
        }
        break;
      case 'question_multiple_color':
        var $selected_answers = $this.prev().find('.selected');
        if ($selected_answers.length > 0) {
          goToNextQuestion($next_slide_index);
        }
        break;

      default:
    }
  });

  $('[data-action="slide-prev"]').on('click', function (el) {
    goToPrevQuestion();
  });

  // On active les 'étoiles' qui viennent d'être passés si on avance de plusieurs slides
  $('.slick-dots').find('.slick-active').prevAll('li:not(.done)').each(function () {
    $(this).toggleClass('done');
  });

  //localStorage.clear();

}(jQuery));